import { render, staticRenderFns } from "./PrintReceiptFrame.vue?vue&type=template&id=0a95d254&scoped=true"
import script from "./PrintReceiptFrame.vue?vue&type=script&lang=js"
export * from "./PrintReceiptFrame.vue?vue&type=script&lang=js"
import style0 from "./PrintReceiptFrame.vue?vue&type=style&index=0&id=0a95d254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95d254",
  null
  
)

export default component.exports